import deviceTypes from "./deviceTypes";

const deviceDefaultMaterials = {
  [deviceTypes.DEV_TYPE_P1V40D_CONTROL]: ["D0101", "IQO1", "M0004", "WWH"], // IQOS_ILUMA_ONE
  [deviceTypes.DEV_TYPE_P1V40V_CHARGER]: ["D0201", "IQO1", "C1502", "WWH"], // IQOS_ILUMA_PRIME_CHARGER
  [deviceTypes.DEV_TYPE_P1V40C_CHARGER]: ["D0201", "IQO1", "M0001", "WWH"], // IQOS_ILUMA_CHARGER
  [deviceTypes.DEV_TYPE_P1V40V_HOLDER_CONTROL]: ["D0101", "IQO1", "C1402", "WWH"], // IQOS_ILUMA PRIME HOLDER
  [deviceTypes.DEV_TYPE_P1V40C_HOLDER_CONTROL]: ["D0101", "IQO1", "C1402", "WWH"], // IQOS_ILUMA HOLDER
  [deviceTypes.DEV_TYPE_P4_M3_G2]: ["D0801", "IQOS", "B1603", "VEEVLUCI"], // IQOS_VEEV
  [deviceTypes.DEV_TYPE_P4_M3_G1]: ["D0801", "VEEV", "B1603", "LUCIDTE"], // IQOS_VEEV
  [deviceTypes.DEV_TYPE_P1V31_CHARGER]: ["D0201", "IQOS", "A1505", "WWH"], // IQOS_3_DUO_Charger
  [deviceTypes.DEV_TYPE_P1V31_HOLDER]: ["D0101", "IQOS", "A1406", "WWH"], // IQOS_3_DUO_Holder
  [deviceTypes.DEV_TYPE_P1V30M]: ["D0101", "IQOS", "A1405", "WWH"], // IQOS_3_MULTI
  [deviceTypes.DEV_TYPE_P1V30_CHARGER]: ["D0201", "IQOS", "A1504", "WWH"], // IQOS_3_Charger
  [deviceTypes.DEV_TYPE_P1V30_HOLDER]: ["D0101", "IQOS", "A1404", "WWH"], // IQOS_3_Charger
  [deviceTypes.DEV_TYPE_V24P_CHARGER]: ["D0201", "IQOS", "A1503", "WWH"], // IQOS_24P_Charger
  [deviceTypes.DEV_TYPE_V24P_HOLDER]: ["D0101", "IQOS", "A1403", "WWH"], // IQOS_24P_Holder
  [deviceTypes.DEV_TYPE_P1_ARIANE]: ["D0101", "BONDS", "M0006", "OCB"], // IQOS_ARIANE
  [deviceTypes.DEV_TYPE_P1V31M]: ["M0301", "IO", "M0011", "SLV"], // IQOS_31_MONOBLADE
  [deviceTypes.DEV_TYPE_P1V41P_CHARGER]: ["D0201", "III", "C1502", "MGB"],
  [deviceTypes.DEV_TYPE_P1V41P_HOLDER_CONTROL]: ["D0101", "III", "C1402", "MGB"],
  [deviceTypes.DEV_TYPE_P1V41_HOLDER_CONTROL]: ["D0101", "III", "C1402", "MGB"],
  [deviceTypes.DEV_TYPE_P1V41M_CHARGER]: ["D0201", "III", "M0001", "MGB"],
  [deviceTypes.DEV_TYPE_P1V41M_HOLDER_CONTROL]: ["D0101", "III", "C1402", "MGB"],
  [deviceTypes.DEV_TYPE_P1V41J_CONTROL]: ["D0101", "III", "M0004", "MGB"]
};

export default deviceDefaultMaterials;
